import { render, staticRenderFns } from "./SalonProcessRating.vue?vue&type=template&id=303dcdfd&"
import script from "./SalonProcessRating.vue?vue&type=script&lang=js&"
export * from "./SalonProcessRating.vue?vue&type=script&lang=js&"
import style0 from "./SalonProcessRating.vue?vue&type=style&index=0&id=303dcdfd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports